import Model from 'src/app/common/model';
import BusinessItemsModel from './businessItems.model';
import FarmSiteModel from './farmSite.model';
import TransactionTypeModel from './transactionType.model';
import ItemMasterModel from './itemMaster.model';
import UOMMasterModel from './uom.model';
import AttachmentsModel from './attachments.model';
import CustomerPondModel from './customerPond.model';
import ItemTypesModel from './itemTypes.model';

export default class TransactionsModel extends Model {
  transactions?: Array<TransactionsModel>;
  transactionResult?: Array<TransactionsModel>;
  BusinessItem: BusinessItemsModel;
  farmSiteDetails: FarmSiteModel; // TC
  TransactionType: TransactionTypeModel;
  ItemMaster: ItemMasterModel;
  UomMaster: UOMMasterModel;
  attachments: Array<AttachmentsModel>;
  pondTransactions?: Array<CustomerPondModel>;
  costManagement?: Array<CostManagement>;
  Pond: CustomerPondModel;// AQU
  transaction_type_id?: number;
  item_id?: string;
  business_item_id?: number;
  business_id?: string;
  source_transaction_id?: number;
  farm_site_id?: string;
  pond_id?: string;
  tank_ids?: Array<string>;
  section_id?: string | number;
  uom_id?: number;
  quantity?: number;
  unit_cost?: number;
  gst_percent?: number;
  gst_value?: number;
  total_cost?: number;
  notes?: Text;
  transaction_date?: string;
  stage?: Stage;
  production_unit_id?: string;
  isBH?: boolean | string;
  inventory: Array<number>;
  toDate: string;
  fromDate: string;
  filePath: string;
  item_name: string;
  sub_type: string;
  packing_size: number;
  vendor_id: number;
  paid_amount: number;
  purchase_amount: number;
  transaction_type: string;
  uomname: string;
  comments: string;
  file_name: string;
  business_name: string;
  farm_location: string;
  section_name: string;
  tank_name: string;
  updated_date: string;
  updated_by: string;
  created_name: string;
  updated_name: string;
  created_by: string;
  created_date: string;
  pond_identifier?: string;
  culture_identifier?: string;
  pond_culture_id?: string;
  itemid: number;
  isInventory: number;
  stockable: boolean;
  item_type_id: number;
  itemtype: string;
  ItemType: ItemTypesModel;
  TankName: string;
  farmSite: FarmSiteModel;// TC
  transactionDate?: string;
  from_date: string;
  to_date: string;
  value?: number;
  ItemsArray?: Array<Items>;
  totalFarmSpend?: number;
  totalExpenditure?: number;
  farmExpenditure?: string;
  pondIdInputDate?: string;
  totalExpenditureValue?: string;
  limit: number;
  offset: number;
  businessName: string;
  farmNameAtLocation: string;

  constructor() {
    super();
  }
}


//////////////////////////////
//CostManagement
//////////////////////////////
export class CostManagement {
  business_id?: string;
  expensecost?: number;
  farm_site_id?: string;
  isBH?: number;
  isInventory?: number;
  itemtype?: string;
  item_id?: number;
  item_name?: string;
  item_type_id?: number;
  percentage?: number;
  production_unit?: string;
  stockable?: number;
  sumofconsumption?: number;
  sumofpurchasecost?: number;
  sumofpurchases?: number;
  total_expenditure?: number;
  unitcost?: number;
  unit_cost?: number;
  uomname?: string;
  uom_id?: number;

  constructor() { }
}

//////////////////////////////
//Items
//////////////////////////////
export class Items {
  item_id?: string
  business_item_id?: string;
  unit_cost?: number;
  value?: number;
  quantity?: number;
  gst_percent?: number;
  gst_value?: number;
  uom_id?: number;
  itemUom?: Array<IItemUOM>;

  constructor() { }
}

//////////////////////////////
//IItemUOM
//////////////////////////////
export class IItemUOM {
  id?: string;
  name?: string;
  uomadded?: boolean;

  constructor() { }
}

export type Stage = 'Preparatory' | 'PostHarvest' | 'Growout';
